import { APP_ENV } from "./../api/network/endpoints";
import dashboardMenuIcons from "../assets/svg/dashboardMenuIcons";
import { ROLE_ACCESS_LEVELS } from "../pages/admin-details/role/constants";
import { ACL_NAMES, useACL } from "../hooks/acl";
import { routeUrls, routeVariables } from "./routeUrls";
import { useLoggedInUserData } from "../utils/user";
import { useLoggedInUserPerms } from "../utils/user";
export type TDashboardMenuItem = {
  slug: string;
  icon: string;
  path: string;
  children?: TDashboardMenuItem[];
  hasQueryParam?: string; // optionally display menu item only if query param is present
};

export const dashboardMenuItemSlugs = [
  "dashboard",
  "maps",
  "reports",
  "manage_roles",
  "maintenance_admin",
  "group_admin",
  "administrators",
  // "manage_rule_alert",
  "asset_alert",
  "panic_alert",
  "camera_admin",
  "compliance_admin",
  "crash_track",
  "incident_review",
];
export const mapsMenuItemSlugs = ["fleet", "asset", "heat", "multiVehicle"];

export const dashboardAdminsMenuItemSlugs = [
  "users", // 0
  "roles", // 1
  "manage_rule_alert", // 2
  "assets", // 3
  "groups", // 4
  "fleettags", // 5
  "drivers", // 6
  "geozones", // 7
  "maintenance", // 8
  "documents", // 9
  "importExport", // 10
  "heatMap", // 11
  "whitelabel_settings", // 12
  "geozone_categories", // 13
  "incident_config", // 14
  "incabcoaching", //15
  "event_colors", // 16
];

export const sysadminMenuItemSlugs = ["enterprises"];

export const useAppMenus = () => {
  const { getUserACLAccessLevel } = useACL();
  const thisOrgViewVideoAllowed = useLoggedInUserData("viewVideoAllowed");
  const thisOrgDriverGroupAllowed = useLoggedInUserData("hasdrivers");
  const thisOrgFleetTagAllowed = useLoggedInUserData("hasfleettags");
  const thisOrgPanicSOSAllowed = useLoggedInUserData("haspanicsos");
  const thisOrgElogEnabledAllowed = useLoggedInUserData("elogenabled");
  const thisOrgCrashtrackEnabled = useLoggedInUserData("crashtrackEnabled");
  const thisOrgGeoCategoriesEnabled = useLoggedInUserData(
    "geoCategoriesEnabled"
  );
  const thisOrgIncidentReviewAllowed = useLoggedInUserData("incidentreviewallowed");
  const thisOrgInCabCoaching = useLoggedInUserData("incabcoachingallowed");
  const { loggedInUserIsManager } = useLoggedInUserPerms();
  const dashboardMenuItems: TDashboardMenuItem[] = [
    //  MANAGED ACCOUNTS TAB (only for managed users)
    ...(loggedInUserIsManager()
      ? [
          {
            slug: "managed_accounts",
            icon: dashboardMenuIcons.admins.users,
            path: routeUrls.dashboardChildren.managedAccounts,
          },
        ]
      : []),
    {
      slug: dashboardMenuItemSlugs[0],
      icon: dashboardMenuIcons.dashboard,
      path: routeUrls.dashboardChildren.overview,
    },
    ...(getUserACLAccessLevel(ACL_NAMES.ACL_MAP_FLEET) >=
    ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardMenuItemSlugs[1],
            icon: dashboardMenuIcons.map_overview,
            path: routeUrls.dashboardChildren.maps,
            children: [
              // fleet map
              // ---------
              {
                slug: mapsMenuItemSlugs[0],
                icon: "",
                path: routeUrls.dashboardChildren.mapsChildren.fleet,
              },

              // asset map
              // ---------
              // ...(getUserACLAccessLevel(ACL_NAMES.ACL_MAP_ASSET) >=
              // ROLE_ACCESS_LEVELS.READ
              //   ? [
              {
                slug: mapsMenuItemSlugs[1],
                icon: "",
                path: routeUrls.dashboardChildren.mapsChildren.vehicle,
                hasQueryParam: routeVariables.vehicleMap.vehicleId,
              },
              //   ]
              // : [])

              // multi-vehicle map
              // -----------------
              ...(getUserACLAccessLevel(ACL_NAMES.ACL_MAP_MULTI_VEHICLE) >=
              ROLE_ACCESS_LEVELS.READ
                ? [
                    {
                      slug: mapsMenuItemSlugs[3],
                      icon: "",
                      path: routeUrls.dashboardChildren.mapsChildren
                        .multiVehicle,
                    },
                  ]
                : []),

              // heat map
              // --------
              ...(getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_HEATMAP) >=
              ROLE_ACCESS_LEVELS.READ
                ? [
                    {
                      slug: mapsMenuItemSlugs[2],
                      icon: "",
                      path: routeUrls.dashboardChildren.mapsChildren.heat,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),
    {
      slug: dashboardMenuItemSlugs[2],
      icon: dashboardMenuIcons.reports,
      path: routeUrls.dashboardChildren.reports,
    },
    ...(thisOrgIncidentReviewAllowed === "1" &&
    getUserACLAccessLevel(ACL_NAMES.ACL_INCIDENT_REVIEW) >=
      ROLE_ACCESS_LEVELS.READ
      ? [
    {
      slug: dashboardMenuItemSlugs[12],
      icon: dashboardMenuIcons.incident_review,
      path: routeUrls.dashboardChildren.incident_review,
    },
       ]
      : []),
    // {
    //   slug: dashboardMenuItemSlugs[7],
    //   icon: dashboardMenuIcons.manage_rule_alert,
    //   path: routeUrls.dashboardChildren.adminChildren.manage_rule_alert,
    // },

    // ...(getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_MAINTENANCE) >=
    // ROLE_ACCESS_LEVELS.READ
    //   ? [
    {
      slug: dashboardMenuItemSlugs[4],
      icon: dashboardMenuIcons.maintenance_admin,
      path: routeUrls.dashboardChildren.maintenance,
    },
    //   ]
    // : []),
    ...(thisOrgPanicSOSAllowed === "1" &&
    getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_ALERTPANEL) >=
      ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardMenuItemSlugs[7],
            icon: dashboardMenuIcons.vehicle_alert,
            path: routeUrls.dashboardChildren.vehicle_alert,
          },
        ]
      : []),
    ...(thisOrgPanicSOSAllowed === "1" &&
    getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_ALERTPANEL) >=
      ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardMenuItemSlugs[8],
            icon: dashboardMenuIcons.buzzer_alert,
            path: routeUrls.dashboardChildren.panic_alert,
          },
        ]
      : []),
    ...(thisOrgViewVideoAllowed === "1" &&
    getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_CAMERA) >= ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardMenuItemSlugs[9],
            icon: dashboardMenuIcons.camera_admin,
            path: routeUrls.dashboardChildren.camera_admin,
          },
        ]
      : []),
    ...(thisOrgElogEnabledAllowed === "1" &&
    getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_COMPLIANCE) >=
      ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardMenuItemSlugs[10],
            icon: dashboardMenuIcons.compliance_admin,
            path: routeUrls.dashboardChildren.compliance_admin,
          },
        ]
      : []),
    ...(thisOrgCrashtrackEnabled === "1" &&
    getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_CRASHTRACK) >=
      ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardMenuItemSlugs[11],
            icon: dashboardMenuIcons.crash_track,
            path: routeUrls.dashboardChildren.crashTrack,
          },
        ]
      : []),
    ...(getUserACLAccessLevel(ACL_NAMES.ACL_SYSADMIN_WHITE_LABEL) >=
    ROLE_ACCESS_LEVELS.WRITE
      ? [
          {
            slug: dashboardAdminsMenuItemSlugs[12],
            icon: dashboardMenuIcons.admins.whitelabel,
            path: routeUrls.dashboardChildren.whiteLabel,
          },
        ]
      : []),
  ];

  const dashboardAdminsMenuItems: TDashboardMenuItem[] = [
    ...(getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_USER_ALL_USERS) >=
    ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardAdminsMenuItemSlugs[0],
            icon: dashboardMenuIcons.admins.user,
            path: routeUrls.dashboardChildren.adminChildren.users,
          },
        ]
      : []),
    ...(getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_ROLE) >=
    ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardAdminsMenuItemSlugs[1],
            icon: dashboardMenuIcons.admins.users,
            path: routeUrls.dashboardChildren.adminChildren.roles,
          },
        ]
      : []),
    ...(getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_RULE) >=
    ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardAdminsMenuItemSlugs[2],
            icon: dashboardMenuIcons.admins.rules,
            path: routeUrls.dashboardChildren.adminChildren.manage_rule_alert,
          },
        ]
      : []),
    ...(getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_ASSET_DEVICE) >=
    ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardAdminsMenuItemSlugs[3],
            icon: dashboardMenuIcons.admins.vehicle,
            path: routeUrls.dashboardChildren.adminChildren.vehicles,
          },
        ]
      : []),
    ...(getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_GROUP) >=
    ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardAdminsMenuItemSlugs[4],
            icon: dashboardMenuIcons.admins.groups,
            path: routeUrls.dashboardChildren.adminChildren.groups,
          },
        ]
      : []),
    ...(thisOrgFleetTagAllowed === "1" &&
    getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_FLEETTAG) >=
      ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardAdminsMenuItemSlugs[5],
            icon: dashboardMenuIcons.admins.truck,
            path: routeUrls.dashboardChildren.adminChildren.fleettags,
          },
        ]
      : []),
    ...(thisOrgDriverGroupAllowed === "1" &&
    getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_DRIVER) >= ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardAdminsMenuItemSlugs[6],
            icon: dashboardMenuIcons.admins.users,
            path: routeUrls.dashboardChildren.adminChildren.drivers,
          },
        ]
      : []),
    ...(getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_GEOZONE) >=
    ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardAdminsMenuItemSlugs[7],
            icon: dashboardMenuIcons.admins.geozone,
            path: routeUrls.dashboardChildren.adminChildren.geozones,
          },
        ]
      : []),
    ...(thisOrgGeoCategoriesEnabled === "1" &&
    getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_GEOZONE) >=
      ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardAdminsMenuItemSlugs[13],
            icon: dashboardMenuIcons.admins.geozone,
            path: routeUrls.dashboardChildren.adminChildren.geozoneCategories,
          },
        ]
      : []),
    // ...(getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_MAINTENANCE) >= ROLE_ACCESS_LEVELS.READ ? [{
    //   slug: dashboardAdminsMenuItemSlugs[8],
    //   icon: dashboardMenuIcons.admins.maintenance,
    //   path: routeUrls.dashboardChildren.maintenance_admin,
    // }] : []),
    ...(getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_DOCUMENT) >=
    ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardAdminsMenuItemSlugs[9],
            icon: dashboardMenuIcons.admins.documents,
            path: routeUrls.dashboardChildren.adminChildren.documents,
          },
        ]
      : []),
      ...(thisOrgIncidentReviewAllowed ==="1" && getUserACLAccessLevel(ACL_NAMES.ACL_INCIDENT_CONFIG) >=
    ROLE_ACCESS_LEVELS.READ
     ?
      [
          {
            slug: dashboardAdminsMenuItemSlugs[14],
            icon: dashboardMenuIcons.admins.incidentReview,
            path: routeUrls.dashboardChildren.adminChildren.incidentReview,
          },
        ]
      : []
    ),

    ...(thisOrgInCabCoaching === "1" && getUserACLAccessLevel(ACL_NAMES.ACL_INCAB_COACHING) >=
    ROLE_ACCESS_LEVELS.READ
     ?
      [
          {
            slug: dashboardAdminsMenuItemSlugs[15],
            icon: dashboardMenuIcons.admins.incabcoaching,
            path: routeUrls.dashboardChildren.adminChildren.inCabCoaching,
          },
        ]
      : []
    ),

    ...(getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_IMPORT_EXPORT) >=
    ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardAdminsMenuItemSlugs[10],
            icon: dashboardMenuIcons.admins.importExport,
            path: routeUrls.dashboardChildren.adminChildren.importExport,
          },
        ]
      : []),
    ...(getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_HEATMAP_CONFIG_ADMIN) >=
    ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardAdminsMenuItemSlugs[11],
            icon: dashboardMenuIcons.admins.heatmap,
            path: routeUrls.dashboardChildren.adminChildren.heatmap,
          },
        ]
      : []),
    ...(getUserACLAccessLevel(ACL_NAMES.ACL_ADMIN_STATUS_CODE) >=
    ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: dashboardAdminsMenuItemSlugs[16],
            icon: dashboardMenuIcons.admins.rules,
            path: routeUrls.dashboardChildren.adminChildren.eventColors,
          },
        ]
      : []),
  ];

  const sysadminMenuItems: TDashboardMenuItem[] = [
    {
      slug: `sysadmin.${sysadminMenuItemSlugs[0]}`,
      icon: dashboardMenuIcons.admins.users,
      path: routeUrls.sysadminChildren.enterprises,
    },
  ];

  return {
    dashboardMenuItems,
    dashboardAdminsMenuItems,
    sysadminMenuItems,
  };
};
